<template>
  <form @submit.prevent="validateBeforeSubmit">
    <b-field grouped>
      <b-field
        label="Título"
        expanded
        :type="{ 'is-danger': errors.has('title') }"
        :message="errors.first('title')"
        size="is-large"
      >
        <b-input
          v-model="data.title"
          name="title"
          maxlength="18"
          :has-counter="false"
          v-validate="'required'"
          data-vv-as="title"
        />
      </b-field>
    </b-field>

    <b-field grouped>
      <b-field :label="`Restrição diária`" expanded>
        <b-input
          placeholder="R$ 100,00"
          v-model="data.dailyAmount"
          v-cleave="masks.currency"
          @input.native="cleaveRefresh"
        />
      </b-field>
      <b-field :label="`Restrição semanal`" expanded>
        <b-input
          placeholder="R$ 100,00"
          v-model="data.weeklyAmount"
          v-cleave="masks.currency"
          @input.native="cleaveRefresh"
        />
      </b-field>
      <b-field :label="`Restrição mensal`" expanded>
        <b-input
          placeholder="R$ 100,00"
          v-model="data.monthlyAmount"
          v-cleave="masks.currency"
          @input.native="cleaveRefresh"
        />
      </b-field>
    </b-field>

    <hr />
    <div class="buttons is-right">
      <router-link class="button is-rounded" :to="'/configuracoes'"
        >Voltar</router-link
      >
      <button
        class="button is-rounded is-primary"
        type="submit"
        @click.prevent="validateAndSubmit"
      >
        Salvar
      </button>
    </div>
  </form>
</template>

<script>
import cleave, { cleaveRefresh, masks } from "../../directives/cleave";

export default {
  props: {
    data: Object
  },
  directives: {
    cleave
  },
  data() {
    return {
      masks,
      cleaveRefresh
    };
  },
  mounted() {},
  methods: {
    validateAndSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("save", this.getRawData());
          return;
        }
        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar.",
          type: "is-danger"
        });
      });
    },
    getRawData() {
      try {
        const rawData = Object.assign({}, this.data);

        rawData.dailyAmount = this.getUnformattedNumber(rawData.dailyAmount);
        rawData.weeklyAmount = this.getUnformattedNumber(rawData.weeklyAmount);
        rawData.monthlyAmount = this.getUnformattedNumber(rawData.monthlyAmount);

        return rawData;
      } catch (error) {
        console.error('error when preparing data to submit.', error);
        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar.",
          type: "is-danger"
        });
      }
    },
    getUnformattedNumber(value) {
      if (value) {
        const theNumer = value.match(/\d+/g).join("");
        return parseInt(theNumer, 10);
      }
    }
  }
};
</script>
